export default __webpack_public_path__ + "static/ahu_w.3ffb34c6c756277ac39a6c0acd377080.svg";